import { configureStore, combineReducers } from '@reduxjs/toolkit';

import templateReducer from './_templateSlice';
import appReducer from './appSlice';
import settingsReducer from './settingsSlice';
import filterMenuReducer from './filterMenuSlice';
import counterReducer from './counterSlice';
import authReducer from './authSlice';
import userReducer from './userSlice';
import companyReducer from './companySlice';
import databaseReducer from './databaseSlice';
import typecodeReducer from './typecodeSlice';
import delayCodeSyncReducer from './delayCodeSyncSlice';
import workCategorySyncReducer from './workCategorySyncSlice';
import branchSyncReducer from './branchSyncSlice';
import franchiseSyncReducer from './franchiseSyncSlice';
import mediaSettingsSyncReducer from './mediaSettingsSyncSlice';
import repairOrderReducer from './repairOrderSlice';
import repairOrderSyncReducer from './repairOrderSyncSlice';
import systemConfigurationsSyncReducer from './systemConfigurationsSyncSlice';
import requestQueueReducer from './requestQueueSlice';
import technicianClockingReducer from './technicianClockingSlice';
import locationReducer from './locationSlice';
import workshopVehicleReducer from './workshopVehicleSlice';
import stockUnitReducer from './stockUnitSlice';
import technicianCommentsReducer from './technicianCommentSlice';
import vehicleAttachmentsReducer from './vehicleAttachmentSlice';
import clockingHistoryReducer from './clockingHistorySlice';
import fixedAssetReducer from './fixedAssetSlice';
import logReducer from './logSlice';

const rootReducer = combineReducers({
  template: templateReducer,
  app: appReducer,
  settings: settingsReducer,
  filterMenu: filterMenuReducer,
  counter: counterReducer,
  auth: authReducer,
  user: userReducer,
  company: companyReducer,
  database: databaseReducer,
  typecode: typecodeReducer,
  delayCodeSync: delayCodeSyncReducer,
  workCategorySync: workCategorySyncReducer,
  branchSync: branchSyncReducer,
  franchiseSync: franchiseSyncReducer,
  mediaSettingsSync: mediaSettingsSyncReducer,
  repairOrder: repairOrderReducer,
  repairOrderSync: repairOrderSyncReducer,
  systemConfigurationsSync: systemConfigurationsSyncReducer,
  requestQueue: requestQueueReducer,
  technicianClocking: technicianClockingReducer,
  location: locationReducer,
  workshopVehicle: workshopVehicleReducer,
  stockUnit: stockUnitReducer,
  technicianComments: technicianCommentsReducer,
  vehicleAttachments: vehicleAttachmentsReducer,
  clockingHistory: clockingHistoryReducer,
  fixedAsset: fixedAssetReducer,
  log: logReducer,
});

const store = configureStore({
  //reducer: createRootReducer(history),
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
